import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { AppTable, EditIcon, DeleteIcon } from '@pro-sto/ui';
import type { AppTableColumn } from '@pro-sto/ui';
import { partnersStore } from '@/stores/PartnersStore';
import type { ServiceCenterItem } from '@/stores/PartnersStore';
import PartnerModal from './PartnerModal';
import DeleteConfirmModal from './DeleteConfirmModal';
import './PartnersPage.css';

const PartnersPage: React.FC = observer(() => {
  useEffect(() => {
    partnersStore.loadServiceCenters();
  }, []);

  const columns: AppTableColumn<ServiceCenterItem>[] = [
    {
      label: 'Название',
      field: 'name',
      width: '25%',
    },
    {
      label: 'Адрес',
      field: 'address',
      width: '35%',
    },
    {
      label: 'Кол-во слотов',
      width: '15%',
      render: (row) => row.postsCount ?? '—',
    },
    {
      label: 'Заказов в месяц',
      width: '15%',
      render: (row) => row.bookingsCount ?? '—',
    },
    {
      label: '',
      width: '10%',
      align: 'right',
      render: (row) => (
        <div className="partners-page__actions">
          <button
            className="partners-page__action-btn"
            onClick={(e) => {
              e.stopPropagation();
              partnersStore.openEditModal(row);
            }}
            title="Редактировать"
            type="button"
          >
            <EditIcon width={18} height={18} />
          </button>
          <button
            className="partners-page__action-btn partners-page__action-btn_danger"
            onClick={(e) => {
              e.stopPropagation();
              partnersStore.confirmDelete(row.uuid);
            }}
            title="Удалить"
            type="button"
          >
            <DeleteIcon width={18} height={18} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="partners-page" data-testid="partners-page">
      <div className="partners-page__header">
        <button
          className="partners-page__add-btn"
          onClick={partnersStore.openCreateModal}
          type="button"
        >
          Добавить партнера
          <span className="partners-page__add-icon">+</span>
        </button>
      </div>

      <div className="partners-page__table-wrap">
        {partnersStore.isLoading ? (
          <div className="partners-page__loading">Загрузка...</div>
        ) : (
          <AppTable<ServiceCenterItem>
            columns={columns}
            rows={partnersStore.serviceCenters}
            getRowKey={(row) => row.uuid}
            emptyPlaceholder="Нет партнеров"
          />
        )}
      </div>

      {partnersStore.isModalOpen && <PartnerModal />}
      {partnersStore.deletingUuid && <DeleteConfirmModal />}
    </div>
  );
});

export default PartnersPage;
